import { Button, makeStyles } from '@material-ui/core';
import React from 'react';
import { useHistory } from 'react-router-dom';


let responsiveLength = "1000";


let useSyles = makeStyles((theme) => ({
    root: {
        // marginTop: 50,
        ...theme.grid.gridMdContent,
        // maxWidth: '100%',
        margin: 'auto',

        minHeight: 350,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',

        [theme.breakpoints.down('1500')]: {
            width: '90%',
        },
        [theme.breakpoints.down('1250')]: {
            // width: '95%',
        },
        [theme.breakpoints.down(responsiveLength)]: {
            minHeight: 525,
        },
        [theme.breakpoints.down('501')]: {
            width: '97%',
        }
    },
    grid: {
        width: '100%',
        margin: 'auto',
        position: 'relative',
        // color: '#ffffff',
        display: 'flex',
        justifyContent: 'space-between',
        justifyContent: 'space-around',

        alignItems: 'center',
        [theme.breakpoints.down('1135')]: {
            flexDirection: 'column-reverse',
        },
        [theme.breakpoints.down(responsiveLength)]: {
            flexDirection: 'column-reverse',
        }
    },
    gridImages: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        [theme.breakpoints.down('1125')]: {
            '& > img': {
                maxWidth: '100%',
                marginBottom: 50
            },
        },
        [theme.breakpoints.down(responsiveLength)]: {
            width: '100%',
      
            justifyContent: 'center',
            '& > img': {
                maxWidth: '100%',
                marginBottom: 50
            },
        }
    },
    desce: {
        margin: '20px 0px',
        width: 500,
        fontSize: 16,
        color: '#000000',
        [theme.breakpoints.down('1500')]: {
            fontSize: 16,
        },
        [theme.breakpoints.down('1250')]: {
            fontSize: 14,
        },
        [theme.breakpoints.down('500')]: {
            width: '90%',
            textAlign: 'justify',
            margin: '20px auto',
        }
    },
    title: {
        fontSize: 30,
        whiteSpace: 'nowrap',
        fontWeight: 700,
        [theme.breakpoints.down('1500')]: {
            fontSize: 26,
        },
        [theme.breakpoints.down('500')]: {
            whiteSpace: 'normal',
            width: '90%',
            margin: 'auto',
            textAlign: 'center'
        }
    },
    gridBtn: {
        width: '94%',
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        marginTop: 10,
        [theme.breakpoints.down(responsiveLength)]: {
            justifyContent: 'space-around',
        },
        [theme.breakpoints.down(responsiveLength)]: {
            flexDirection: 'column',
            width: '100%',
            justifyContent: 'center'
        },
        [theme.breakpoints.down(500)]: {
            width: '90%',
            margin: 'auto'
        },
    },
    btnWhite: {
        padding: '0px 25px',
        fontSize: 16,
        [theme.breakpoints.down('500')]: {
            width: '90%',
            margin: 'auto',
            justifyContent: 'center',
        },
    },
    btnRed: {
        // width: '58%',
        backgroundColor: theme.palette.light.type2,
        color: "white !important",
        margin: "0px 5px 0px 0px",
        padding: '9px 20px',
        border: `1px solid ${theme.palette.light.type2}`,
        fontSize: 14,
        whiteSpace: 'nowrap',
        [theme.breakpoints.down("1236")]: {
            padding: '9px 30px',
        },
        '&:hover': {
            backgroundColor: "transparent",
            color: "#071b2c !important",
            border: `1px solid black `,
        },
        [theme.breakpoints.down(responsiveLength)]: {
            width: '100%',
            margin: 0
        },
    },
    line: {
        borderRadius: 3,
        height: 4,
        border: 'none',
        backgroundColor: theme.palette.light.type2,
        position: 'absolute',
        top: -10,
        width: 30,
        [theme.breakpoints.down('1135')]: {
            top: -10,
            display: 'none'
        },
        [theme.breakpoints.down(responsiveLength)]: {
            top: -10,
            display: 'none'
        }
    },
    gridIconRight: {
        width: 50,
        marginRight: 40,
        [theme.breakpoints.down(responsiveLength)]: {
            marginRight: 0,
            display: 'none',
        }
    },
    gridIconLeft: {
        width: 50,
        marginLeft: 0,
        transform: "rotate(180deg)",
        [theme.breakpoints.down(responsiveLength)]: {
            marginLeft: 0,
            display: 'none',
        }
    },
    icon: {
        width: 50,
    },
    gridContent: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        [theme.breakpoints.down(responsiveLength)]: {
            marginRight: 0,
            marginTop: 20,
            textAlign: 'center',
            width: '100%',
            justifyContent: 'center',
        }
    },
    bgBtn: {
        height: 40,
        width: 40,
        padding: 5,
        backgroundColor: '#132b41',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: 9,
        cursor: 'pointer',
        '&:hover': {
            backgroundColor: 'rgba(255,255,255,0.2)',
        }
    },
    gridIcons: {
        width: 13,
        height: 13,
        padding: 10,
        borderRadius: '50%',
        backgroundColor: '#49A629',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    cardList: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginRight: 20,
        marginBottom: 15,
    },
    titleIcons: {
        marginBottom: 0,
        marginLeft: 10,
        fontWeight: 700,
        fontSize: 16,
    },
    gridCardList: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        [theme.breakpoints.down('500')]: {
            justifyContent: 'center',
            flexWrap: 'wrap',
            flexDirection: 'column',
        },
    },
    iconArrowLeft: {
        marginLeft: 10,
    }
}))

export default function Index({ data }) {

    let classes = useSyles();
    const history = useHistory();


    const handelRout = (path) => {
        window.scrollTo(0, 0);
        history.push(path);
    }

    return (
        <div className={classes['root']}>
            <div className={classes['grid']}>
                <div style={{ position: 'relative' }} >
                    <div>
                        <div className={classes['line']} />
                        <h3 className={classes['title']}>
                            کارگزاری پویان، سرمایه‌گذاری بی‌پایان...
                        </h3>
                        <p className={classes['desce']}>
                            کارگزاری پویان به عنوان یک کارگزار بازار سرمایه با شعار سرمایه گذاری بی پایان، با افتخار شریک سرمایه گذاران در این سفر هیجان‌انگیز به آینده مالی بی‌پایان، پایدار و بلند مدت هستیم. سرمایه گذاران همراه ما هستند و از هر لحظه‌ای برای شروع به سرمایه‌گذاری در آینده‌ خود بهره می برند.
                        </p>
                        <div className={classes['gridCardList']}>
                            <div className={classes['cardList']}>
                                <div className={classes['gridIcons']}>
                                    <img src='/assets/images/arrow_Left.png' alt='' />
                                </div>
                                <p className={classes['titleIcons']}>
                                    تنوع در سرمایه گذاری
                                </p>
                            </div>
                            <div className={classes['cardList']}>
                                <div className={classes['gridIcons']}>
                                    <img src='/assets/images/arrow_Left.png' alt='' />
                                </div>
                                <p className={classes['titleIcons']}>
                                    استراتژی‌های نوآورانه
                                </p>
                            </div>
                        </div>
                        <div className={classes['gridCardList']}>
                            <div className={classes['cardList']}>
                                <div className={classes['gridIcons']}>
                                    <img src='/assets/images/arrow_Left.png' alt='' />
                                </div>
                                <p className={classes['titleIcons']}>
                                    آینده مالی بلند مدت و بی پایان
                                </p>
                            </div>
                            <div className={classes['cardList']}>
                                <div className={classes['gridIcons']}>
                                    <img src='/assets/images/arrow_Left.png' alt='' />
                                </div>
                                <p className={classes['titleIcons']}>
                                    مدیریت ریسک
                                </p>
                            </div>
                        </div>
                        <div className={classes['gridBtn']}>
                            {/* <Button
                                    className={classes.btnRed}
                                    href={'/deceased-people'}
                                >
                                    از پویان بیشتر بدانید

                                </Button> */}

                            <button type="" className={`${classes['btnWhite']} btnPouyanWhite`} onClick={() => { handelRout('/AboutUs') }}>
                                از پویان بیشتر بدانید
                                <img src='/assets/images/VectorRight.png' alt='' className={classes['iconArrowLeft']} />
                            </button>
                            {/* <Button
                                className={classes.btnWhite}
                                href={'/deceased'}
                            // href={`tel:${'02153782000'}`}
                            >
                                از پویان بیشتر بدانید

                            </Button> */}

                        </div>
                    </div>
                    <div>

                    </div>
                </div>
                <div className={classes['gridImages']}>
                    <img src={'/assets/images/mony.png'} alt={data?.title} />
                </div>
            </div>
        </div >)
}
